// man_suffixes.json
var man_suffixes_default = {
  "": "e",
  sch: "schi",
  gr: "g\u0159e",
  ppek: "ppku",
  \u0161vec: "\u0161veci",
  tr: "t\u0159e",
  spek: "spku",
  th: "the",
  vel: "vle",
  urec: "ur\u010De",
  feric: "ferici",
  \u00F3rek: "\xF3rku",
  rel: "rle",
  urek: "urku",
  \u010Damr: "\u010Dam\u0159e",
  ius: "ie",
  hdr: "hdr",
  jha: "jho",
  sych: "sychu",
  hlec: "hl\u010De",
  ypek: "ypku",
  khodr: "khodre",
  \u00EDrek: "\xEDrku",
  zh: "zhi",
  xandr: "xandre",
  \u00EDrec: "\xEDr\u010De",
  bakr: "bakre",
  \u016Fha: "\u016Fho",
  t\u0159ek: "t\u0159eku",
  zr: "z\u0159e",
  ylev: "yleve",
  yandr: "yandre",
  mpek: "mpku",
  ych: "ychi",
  ylec: "yl\u010De",
  klec: "kl\u010De",
  lec: "leci",
  rbek: "rbku",
  bh: "bhe",
  lel: "lle",
  deric: "derici",
  kamr: "kam\u0159e",
  drek: "drku",
  klev: "kleve",
  lev: "lve",
  \u00EDha: "\xEDho",
  \u0161: "\u0161i",
  k: "ku",
  zbek: "zbku",
  janus: "janusi",
  g\u00E1l: "g\xE1le",
  zenec: "zen\u010De",
  reichel: "reichle",
  t\u00E1nus: "t\xE1nusi",
  \u013Eha: "\u013Eho",
  hrek: "hrku",
  cha: "cho",
  prek: "prku",
  fel: "fle",
  unych: "unychu",
  fotr: "fot\u0159e",
  rlec: "rl\u010De",
  \u00FCrek: "\xFCrku",
  kbek: "kbku",
  lnych: "lnychu",
  rlev: "rleve",
  mlev: "mleve",
  olev: "oleve",
  xha: "xho",
  t\u00EDnus: "t\xEDne",
  \u0148ha: "\u0148ho",
  del: "deli",
  olec: "ol\u010De",
  kozel: "kozle",
  mr: "m\u0159e",
  stinus: "stine",
  mnych: "mnychu",
  \u011B: "\u011B",
  \u00E1bek: "\xE1bku",
  \u00E1rec: "\xE1r\u010De",
  \u00E1rek: "\xE1rku",
  lamr: "lam\u0159e",
  pytel: "pytle",
  gey: "geyi",
  fr: "f\u0159e",
  auzel: "auzele",
  irek: "irku",
  \u016Fbek: "\u016Fbku",
  irec: "ir\u010De",
  a: "o",
  pych: "pychu",
  llev: "lleve",
  lha: "lho",
  \u016Frek: "\u016Frku",
  sr: "s\u0159e",
  \u011Bnec: "\u011Bnci",
  llec: "ll\u010De",
  sh: "shi",
  gha: "gho",
  uzel: "uzle",
  \u010D\u00E1l: "\u010D\xE1le",
  p\u0159ek: "p\u0159eku",
  jpek: "jpku",
  s\u00E1l: "s\xE1le",
  fbek: "fbku",
  enec: "enci",
  \u00FCbek: "\xFCbku",
  glec: "gl\u010De",
  apek: "apku",
  cec: "ceci",
  uha: "uho",
  cel: "celi",
  k\u00E1l: "k\xE1le",
  aanus: "aanusi",
  bych: "bychu",
  k\u0159ek: "k\u0159eku",
  ebek: "ebku",
  alev: "aleve",
  u\u010De\u0148: "u\u010Dni",
  alec: "al\u010De",
  \u00E1ha: "\xE1ho",
  ek: "ku",
  \u010D: "\u010Di",
  ec: "\u010De",
  \u00FApek: "\xFApku",
  opek: "opku",
  stus: "ste",
  rey: "reyi",
  rr: "r\u0159e",
  rek: "reku",
  tbek: "tbku",
  dinus: "dine",
  abenec: "aben\u010De",
  rec: "reci",
  plev: "pleve",
  hanus: "hanusi",
  onych: "onychu",
  j\u00E1gr: "j\xE1gre",
  n\u011Bk: "\u0148ku",
  vlev: "vleve",
  g: "gu",
  \u011Bpek: "\u011Bpku",
  ntinus: "ntine",
  nha: "nho",
  ulev: "uleve",
  uel: "ueli",
  hehr: "hehre",
  upenec: "upen\u010De",
  ulec: "ul\u010De",
  t\u00E1l: "t\xE1le",
  tel: "teli",
  iha: "iho",
  \u00EDpek: "\xEDpku",
  iksey: "iksey",
  jel: "jle",
  anus: "ane",
  kpek: "kpku",
  \u00FDrek: "\xFDrku",
  upek: "upku",
  treichel: "treicheli",
  \u00FDbek: "\xFDbku",
  trek: "trku",
  bel: "beli",
  trec: "tr\u010De",
  \u00ED: "\xED",
  vnych: "vnychu",
  grec: "gr\u010De",
  nbek: "nbku",
  \u00FD: "\xFD",
  \u0161el: "\u0161eli",
  atinus: "atine",
  krek: "krku",
  ibek: "ibku",
  ynych: "ynychu",
  gnych: "gnychu",
  sr\u0161e\u0148: "sr\u0161ni",
  \u00EDlec: "\xEDl\u010De",
  rpek: "rpku",
  lych: "lychu",
  bbek: "bbku",
  rha: "rho",
  brek: "brku",
  \u0159el: "\u0159eli",
  ceric: "cerici",
  hbek: "hbku",
  \u00FAha: "\xFAho",
  mbek: "mbku",
  gintr: "gintre",
  \u011Bl: "\u011Bli",
  t\u011Bk: "\u0165ku",
  inych: "inychu",
  lay: "layi",
  exandr: "exand\u0159e",
  szmek: "szmeku",
  meric: "merici",
  rajr: "rajre",
  yasr: "yasee",
  \u0161rek: "\u0161rku",
  xel: "xle",
  iel: "ieli",
  lpek: "lpku",
  bek: "beku",
  \u00EDel: "\xEDle",
  kleandr: "kleand\u0159e",
  \u00E9rek: "\xE9rku",
  dr: "d\u0159e",
  gel: "geli",
  ipek: "ipku",
  h: "hu",
  sha: "sho",
  \u00F3: "\xF3",
  dych: "dychu",
  x: "xi",
  ietr: "ietre",
  ael: "aeli",
  \u017E: "\u017Ei",
  blev: "bleve",
  ud\u011Bk: "u\u010Fku",
  \u0161r: "\u0161\u0159e",
  blec: "bl\u010De",
  sel: "sle",
  erec: "er\u010De",
  erek: "erku",
  hamr: "ham\u0159e",
  \u00E1pek: "\xE1pku",
  rtinus: "rtine",
  kel: "kle",
  \u0165\u00E1l: "\u0165\xE1le",
  enych: "enychu",
  jr: "j\u0159e",
  cych: "cychu",
  \u0159: "\u0159i",
  c: "ci",
  rych: "rychu",
  s: "si",
  datel: "datli",
  \u00E1lec: "\xE1l\u010De",
  sbek: "sbku",
  cr: "c\u0159e",
  pr: "p\u0159e",
  jrek: "jrku",
  \u013Aha: "\u013Aho",
  ph: "phe",
  nrec: "nr\u010De",
  \u0148: "ni",
  gbek: "gbku",
  otr: "otre",
  yrek: "yrku",
  \u00E9: "\xE9",
  buben: "bubne",
  ruzel: "ruzele",
  iy: "iyi",
  dbek: "dbku",
  eandr: "eandre",
  olexandr: "olexandre",
  vr: "v\u0159e",
  ybek: "ybku",
  ubek: "ubku",
  dha: "dho",
  rnych: "rnychu",
  rrek: "rrku",
  \u00FArek: "\xFArku",
  \u00E1nus: "\xE1ne",
  wych: "wychu",
  pha: "pho",
  vrek: "vrku",
  sadr: "sadre",
  \u00E4r: "\xE4\u0159e",
  elec: "el\u010De",
  i: "i",
  yha: "yho",
  \u00E4el: "\xE4le",
  elev: "eleve",
  y: "y",
  tha: "tho",
  o\u0161vec: "o\u0161v\u010De",
  mrek: "mrku",
  yel: "yle",
  tych: "tychu",
  \u00E1l: "\xE1li",
  wrek: "wrku",
  \u011Blec: "\u011Bl\u010De",
  \u016Fpek: "\u016Fpku",
  xey: "xeyi",
  jlec: "jl\u010De",
  \u00E9bek: "\xE9bku",
  bnych: "bnychu",
  wel: "wle",
  \u0165ha: "\u0165ho",
  amr: "amre",
  \u00FAbek: "\xFAbku",
  tlev: "tleve",
  mha: "mho",
  eel: "ele",
  \u010Del: "\u010Dle",
  dmehr: "dmehre",
  zejr: "zejee",
  \u00E9ha: "\xE9ho",
  \u00EDbek: "\xEDbku",
  pel: "ple",
  pek: "peku",
  ilec: "il\u010De",
  mitr: "mitre",
  ilev: "ileve",
  \u0159pek: "\u0159pku",
  br: "b\u0159e",
  obek: "obku",
  \u00E9pek: "\xE9pku",
  \u0165: "ti",
  orek: "orku",
  lbek: "lbku",
  pietr: "piet\u0159e",
  o: "o",
  orec: "or\u010De",
  aha: "aho",
  barr: "barre",
  batr: "batre",
  abek: "abku",
  ksey: "kseyi",
  arec: "ar\u010De",
  arek: "arku",
  eha: "eho",
  hel: "heli",
  \u0161pek: "\u0161pku",
  hr: "h\u0159e",
  \u011Brek: "\u011Brku",
  ha: "hao",
  zych: "zychu",
  aksandr: "aksandre",
  mych: "mychu",
  j: "ji",
  zha: "zho",
  duben: "dubne",
  z: "zi",
  vha: "vho",
  \u00FCr: "\xFC\u0159e",
  epek: "epku",
  khr: "khre",
  oha: "oho",
  \u010F: "di",
  \u00F3bek: "\xF3bku",
  kha: "kho",
  eric: "ericu",
  hnych: "hnychu",
  kr: "k\u0159e",
  heric: "herici",
  vanus: "vanusi",
  nnych: "nnychu",
  cbek: "cbku",
  e: "e",
  \u016F: "\u016F",
  \u017Eel: "\u017Eeli",
  u: "u"
};

// man_vs_woman_suffixes.json
var man_vs_woman_suffixes_default = {
  "": "m",
  usova: "w",
  sca: "w",
  ala: "w",
  b\u00E1ra: "w",
  lli: "w",
  \u0161inka: "m",
  mila: "w",
  ardina: "w",
  \u0161tina: "m",
  zendulka: "m",
  aud: "w",
  d\u0159icha: "w",
  myla: "w",
  \u011Btla: "w",
  nita: "w",
  xandra: "w",
  bzina: "m",
  nora: "w",
  eorg: "m",
  \u0165ala: "m",
  lore: "w",
  palica: "m",
  te: "w",
  heda: "w",
  zd\u011Bnka: "w",
  dela: "m",
  latu\u0161ka: "w",
  hlena: "m",
  vla: "w",
  iama: "w",
  vera: "w",
  l\u00EDda: "w",
  radina: "m",
  elenka: "m",
  zela: "m",
  jelen: "m",
  ieda: "w",
  \u017Eina: "m",
  ne\u0161a: "w",
  hnila: "m",
  \u00E9la: "w",
  eva: "w",
  atava: "w",
  m\u00E1ja: "w",
  aula: "w",
  osolda: "m",
  laura: "w",
  piva: "m",
  ndora: "m",
  rala: "m",
  lisa: "m",
  ngela: "w",
  lavka: "w",
  ilda: "w",
  vela: "m",
  \u0161vanda: "m",
  \u011B\u0161ka: "w",
  \u011Btu\u0161ka: "w",
  obora: "m",
  manta: "w",
  elisa: "w",
  acia: "m",
  \u010Dina: "m",
  \u0159ada: "m",
  mbora: "m",
  run: "w",
  \u0161anca: "m",
  mela: "m",
  meg: "w",
  hda: "w",
  aja: "m",
  sl\u00E1vka: "w",
  vadina: "m",
  zona: "m",
  onga: "m",
  avera: "m",
  iara: "w",
  bolina: "m",
  t\u011Bna: "m",
  sinka: "m",
  u\u0161ana: "w",
  sina: "m",
  czna: "w",
  eni: "w",
  kvan: "m",
  kolena: "m",
  amela: "w",
  ilja: "m",
  my: "w",
  rbara: "w",
  b\u011Bna: "m",
  milka: "w",
  ezda: "w",
  ibu\u0161a: "w",
  karin: "w",
  viga: "w",
  myra: "w",
  doris: "w",
  anata: "m",
  gustina: "w",
  ozd\u011Bna: "m",
  riena: "w",
  org: "w",
  rauda: "w",
  atina: "m",
  janina: "w",
  ghia: "m",
  dne: "m",
  use: "m",
  raida: "m",
  an\u011Bna: "m",
  tela: "m",
  stina: "m",
  \u017Eenka: "w",
  sefka: "w",
  \u0161ina: "m",
  liva: "m",
  ulma: "m",
  zdenka: "w",
  kalina: "m",
  aina: "m",
  hani\u010Dka: "w",
  eresa: "w",
  ur\u0161ula: "w",
  mira: "w",
  efa: "w",
  eodora: "w",
  \u0159ela: "m",
  lema: "m",
  rion: "w",
  \u0161ana: "m",
  \u00E1: "w",
  yja: "m",
  wanda: "w",
  taud: "m",
  arang: "m",
  mi: "w",
  valla: "m",
  balla: "m",
  \u0161enka: "w",
  edes: "w",
  carmen: "w",
  lb\u00EDna: "w",
  mala: "m",
  ohunka: "w",
  eidi: "w",
  ia: "w",
  linka: "m",
  helina: "w",
  s\u0165a: "w",
  palla: "m",
  ngan: "w",
  alada: "m",
  ene: "m",
  zlata: "w",
  vira: "w",
  pina: "m",
  wiga: "w",
  vska: "w",
  galla: "m",
  hi: "w",
  nya: "m",
  nuta: "w",
  opolda: "w",
  volena: "m",
  lah: "m",
  evera: "m",
  lida: "m",
  diva: "m",
  r\u00FAt: "w",
  blanka: "w",
  dlenka: "m",
  ova: "w",
  oleta: "w",
  lanka: "m",
  dvan: "m",
  zata: "w",
  lu\u0161a: "w",
  tala: "m",
  tvan: "m",
  stra: "w",
  vika: "w",
  tali: "w",
  llen: "w",
  se: "w",
  eata: "w",
  lenka: "w",
  v\u011Brka: "w",
  lsa: "w",
  urina: "m",
  terna: "m",
  asula: "m",
  apolena: "w",
  clava: "w",
  unga: "m",
  ryka: "w",
  vita: "w",
  cole: "w",
  ilva: "w",
  \u0161atava: "m",
  cola: "w",
  llya: "m",
  rika: "w",
  hanka: "m",
  thang: "m",
  l\u00E1va: "w",
  tsa: "w",
  minka: "m",
  lu: "w",
  \u013Ega: "w",
  ivonka: "w",
  ly: "w",
  walla: "m",
  malina: "m",
  c\u00EDna: "m",
  katka: "w",
  ya: "w",
  nada: "m",
  ziva: "m",
  hala: "m",
  ester: "w",
  omana: "w",
  kvita: "m",
  uryna: "m",
  alisa: "w",
  ther: "w",
  te\u0159ina: "w",
  vitha: "m",
  dv\u00EDka: "w",
  \u00F3ra: "w",
  \u017Eanka: "m",
  dinga: "m",
  yna: "w",
  kyna: "m",
  \u0159inka: "m",
  \u0161\u00E1rka: "w",
  enora: "m",
  anka: "w",
  erta: "w",
  onica: "w",
  illi: "m",
  ruth: "w",
  illa: "m",
  vada: "m",
  psia: "m",
  rska: "w",
  eja: "m",
  p\u00E1nka: "w",
  ytina: "m",
  \u011Blina: "m",
  got: "w",
  stela: "w",
  zabela: "w",
  izela: "w",
  itina: "m",
  tinka: "m",
  ubica: "w",
  atica: "w",
  \u011Bja: "m",
  elina: "m",
  ase: "m",
  ulawa: "m",
  \u017Eana: "m",
  lma: "w",
  mma: "w",
  asova: "w",
  ezina: "m",
  zorka: "w",
  ko\u0148a: "m",
  ysela: "m",
  utina: "m",
  \u010Dinka: "m",
  amanda: "w",
  ahu\u0161ka: "w",
  o\u0148a: "w",
  mida: "m",
  lla: "w",
  isa: "w",
  \u017Eena: "w",
  halka: "w",
  rang: "w",
  rana: "m",
  ona: "w",
  ylva: "w",
  khanh: "m",
  justina: "w",
  dolina: "m",
  bala: "m",
  halla: "m",
  \u00E9na: "w",
  eli\u0161ka: "w",
  j\u00EDna: "m",
  \u010Dela: "m",
  edina: "m",
  zala: "m",
  indulka: "m",
  rinka: "m",
  l\u00E1ra: "w",
  estina: "w",
  \u017Eb\u011Bta: "w",
  cinka: "m",
  p\u011Bna: "m",
  rnuta: "m",
  olma: "m",
  ubina: "m",
  nilica: "m",
  dyna: "m",
  nca: "w",
  nce: "m",
  tiva: "m",
  riska: "w",
  galia: "m",
  k\u00F3: "w",
  ylda: "w",
  apova: "w",
  rvara: "w",
  dinka: "m",
  agata: "w",
  rena: "w",
  i\u0159inka: "w",
  ana: "w",
  \u010Dada: "m",
  st\u00E1\u0148a: "m",
  anh: "w",
  odora: "m",
  na\u010Fa: "w",
  adela: "w",
  gala: "m",
  \u00E1ly: "m",
  \u00EDna: "w",
  sula: "w",
  rzina: "m",
  nikola: "w",
  lila: "w",
  \u00FDna: "w",
  nifer: "w",
  arleta: "w",
  v\u011Bta: "w",
  linda: "w",
  \u010Fala: "m",
  alsa: "m",
  hutta: "m",
  urga: "w",
  arika: "m",
  deni\u010Dka: "w",
  sandra: "w",
  inka: "w",
  aryta: "w",
  beth: "w",
  lfriede: "w",
  icol: "w",
  \u0159i\u0161ka: "w",
  \u011Bna: "w",
  olasta: "m",
  sala: "m",
  pleva: "m",
  indy: "w",
  maja: "w",
  antina: "m",
  talla: "m",
  dulka: "w",
  bada: "m",
  rvan: "m",
  arla: "w",
  nd\u011Bla: "w",
  ulla: "m",
  s\u00E1ra: "w",
  olha: "w",
  etelka: "w",
  brenda: "w",
  linh: "w",
  nther: "m",
  olavka: "m",
  t\u00E1\u0148a: "w",
  \u00E9e: "w",
  orica: "w",
  nga: "w",
  \u00E9fa: "w",
  traut: "w",
  avan: "m",
  jam: "w",
  ikol: "w",
  \u00E1lenka: "m",
  mena: "w",
  sily: "m",
  jitka: "w",
  \u0159iva: "m",
  metelka: "m",
  du: "w",
  ssa: "w",
  ulina: "m",
  estera: "w",
  ema: "w",
  vien: "w",
  gda: "w",
  rabina: "m",
  gela: "m",
  \u013Aga: "w",
  kalla: "m",
  ines: "w",
  e\u0148ka: "w",
  olanta: "w",
  i\u00E1na: "w",
  rlota: "w",
  vina: "m",
  emina: "m",
  tta: "w",
  peta: "m",
  rada: "m",
  inge: "w",
  gelina: "w",
  iera: "w",
  karmen: "w",
  imara: "m",
  vala: "m",
  rita: "w",
  huong: "w",
  dejda: "w",
  ezanka: "m",
  vinka: "m",
  wa: "w",
  garda: "w",
  ilica: "w",
  erna: "w",
  je: "w",
  iki: "w",
  istina: "w",
  ja: "w",
  thanh: "m",
  obru\u0161ka: "w",
  herna: "m",
  nila: "w",
  juba: "w",
  keta: "m",
  ilija: "m",
  ili: "w",
  mana: "m",
  eta: "w",
  ete: "m",
  manh: "m",
  dora: "w",
  rista: "w",
  tona: "m",
  gita: "w",
  bela: "m",
  etra: "w",
  gerda: "w",
  ce: "w",
  \u011Btina: "m",
  berna: "m",
  cy: "w",
  m\u00EDla: "w",
  iola: "w",
  metela: "m",
  wska: "w",
  zitta: "m",
  mara: "w",
  sara: "w",
  i\u0159ina: "w",
  \u0161tka: "w",
  helma: "m",
  ivera: "m",
  klika: "m",
  oleva: "m",
  lga: "w",
  p\u00E1ta: "m",
  enina: "m",
  ao: "w",
  rdina: "m",
  velina: "w",
  ry\u0161a: "w",
  polena: "m",
  nska: "w",
  ysa: "w",
  odina: "m",
  lv\u00EDra: "w",
  tana: "m",
  b\u011Bla: "w",
  \u011Bdunka: "w",
  rema: "m",
  iala: "m",
  iva: "w",
  thuy: "w",
  eszka: "w",
  pinka: "m",
  enga: "m",
  tska: "w",
  binka: "m",
  solda: "w",
  \u00E9ta: "w",
  ilya: "m",
  refa: "m",
  rid: "w",
  ie: "w",
  \u010Dala: "m",
  \u00E9ma: "w",
  nika: "w",
  italy: "m",
  mrska: "m",
  mirka: "w",
  cina: "m",
  jasna: "w",
  itali: "m",
  verna: "m",
  d\u00E1\u0161a: "w",
  otta: "m",
  eila: "w",
  slava: "w",
  sada: "m",
  olada: "m",
  zita: "w",
  hang: "w",
  rketa: "w",
  elle: "w",
  lska: "w",
  marta: "w",
  \u00E1slavka: "m",
  \u0161ala: "m",
  nesa: "w",
  e\u017Eda: "w",
  endula: "w",
  dzia: "m",
  thu: "w",
  dada: "m",
  elen: "w",
  \u010Fka: "w",
  valina: "m",
  ib\u011Bna: "w",
  isabela: "w",
  izina: "m",
  ozina: "m",
  cca: "w",
  uja: "m",
  tha: "w",
  kala: "m",
  yen: "w",
  ne: "w",
  tnia: "m",
  narda: "w",
  sova: "m",
  danu\u0161ka: "w",
  yet: "w",
  leta: "m",
  aru\u0161ka: "w",
  vida: "m",
  ela: "w",
  kania: "m",
  v\u011Bra: "w",
  truda: "w",
  esika: "w",
  aulina: "w",
  ely: "m",
  ada: "w",
  \u00E1ja: "m",
  nata: "w",
  loan: "w",
  ami: "m",
  ulenka: "m",
  irenka: "w",
  lilija: "w",
  \u017Eala: "m",
  vranka: "m",
  dita: "w",
  rlina: "m",
  vanda: "w",
  dlina: "m",
  dith: "w",
  vlice: "m",
  lika: "w",
  orota: "w",
  lilian: "w",
  \u00E1ta: "w",
  alica: "w",
  dlena: "m",
  \u0159enka: "w",
  havlina: "m",
  \u017Eela: "m",
  ivan: "m",
  \u011Bru\u0161ka: "w",
  czina: "m",
  johanka: "w",
  holu\u0161a: "m",
  idu\u0161ka: "w",
  kysa: "m",
  alu\u0161ka: "m",
  nti\u0161ka: "w",
  p\u00E1na: "w",
  ije: "m",
  pala: "m",
  oly: "m",
  melen: "m",
  u\u0161e: "w",
  ovan: "m",
  bora: "w",
  zlatka: "w",
  lotta: "w",
  sitta: "m",
  vilda: "m",
  uyen: "m",
  lara: "w",
  isova: "w",
  dda: "w",
  pela: "m",
  no\u0161ta: "w",
  nida: "m",
  beka: "w",
  lasta: "w",
  usan: "w",
  esna: "w",
  reza: "w",
  gmar: "w",
  heta: "m",
  \u0159ala: "m",
  udina: "m",
  \u0161anka: "m",
  iris: "w",
  hyna: "m",
  nhung: "w",
  oe: "w",
  nde: "w",
  p\u00EDna: "m",
  \u0159ina: "m",
  tomi: "m",
  jurga: "m",
  tsova: "w",
  alga: "m",
  ores: "w",
  gnes: "w",
  citas: "w",
  gard: "w",
  lien: "w",
  zadina: "m",
  lies: "w",
  marika: "w",
  jena: "w",
  wada: "m",
  cvan: "m",
  \u0161van: "m",
  git: "w",
  van: "w",
  hly: "m",
  \u0165\u00E1na: "w",
  acola: "m",
  lvina: "w",
  dena: "w",
  smin: "w",
  da\u0161a: "w",
  danica: "w",
  rela: "m",
  klenka: "m",
  ugda: "m",
  halica: "m",
  zora: "w",
  ryla: "w",
  idka: "w",
  ea: "w",
  vester: "m",
  lu\u0161ka: "w",
  trun: "m",
  mice: "m",
  trud: "w",
  \u011B\u017Eda: "w",
  oa: "w",
  mada: "m",
  vlena: "m",
  \u010Diva: "m",
  etela: "w",
  atta: "m",
  ue: "w",
  merta: "m",
  hlada: "m",
  aa: "w",
  m\u00EDra: "w",
  oryna: "m",
  trin: "w",
  pova: "m",
  jenny: "w",
  ah: "w",
  nna: "w",
  r\u00EDda: "w",
  lyn: "w",
  czyna: "m",
  radka: "w",
  ina: "w",
  opova: "w",
  ida: "w",
  colle: "w",
  anina: "m",
  ichala: "w",
  e\u017Eka: "w",
  b\u00EDna: "m",
  halenka: "m",
  kira: "w",
  sica: "w",
  riam: "w",
  dolfa: "w",
  \u011Bdina: "m",
  lena: "w",
  ata\u0161a: "w",
  dala: "m",
  lene: "w",
  irma: "w",
  szula: "w",
  lola: "w",
  walica: "m",
  \u0161vera: "m",
  ravka: "w",
  palma: "m",
  huyen: "w",
  \u0161eta: "m",
  ovanda: "m",
  fela: "m",
  perna: "m",
  kubica: "m",
  ipova: "w",
  helenka: "w",
  tima: "w",
  ilonka: "w",
  etina: "m"
};

// woman_first_vs_last_name_suffixes.json
var woman_first_vs_last_name_suffixes_default = {
  "": "l",
  ith: "l",
  ali: "f",
  phung: "l",
  lli: "f",
  ryka: "f",
  lle: "f",
  le: "l",
  ham: "l",
  hao: "f",
  tsa: "l",
  yma: "l",
  ska: "l",
  th: "f",
  di: "f",
  ye: "l",
  ones: "l",
  dt: "l",
  dith: "f",
  seva: "l",
  d: "f",
  t: "f",
  el: "f",
  en: "f",
  ei: "f",
  ole: "f",
  ee: "l",
  ze: "l",
  ey: "l",
  sen: "l",
  es: "f",
  rt: "l",
  yka: "l",
  erg: "l",
  huong: "f",
  ba: "l",
  ster: "f",
  les: "l",
  iki: "f",
  ol: "f",
  g: "f",
  od: "l",
  oc: "f",
  ili: "f",
  ov: "f",
  rang: "f",
  iang: "f",
  guyen: "l",
  loan: "f",
  ong: "l",
  dinh: "l",
  rinh: "l",
  ian: "f",
  van: "f",
  yeva: "l",
  fer: "f",
  \u010Deva: "l",
  hen: "l",
  gan: "f",
  hi: "f",
  eeva: "l",
  \u00E9: "f",
  mi: "f",
  k\u00F3: "f",
  un: "f",
  iy: "l",
  ang: "l",
  san: "f",
  ai: "f",
  ah: "f",
  is: "f",
  in: "f",
  as: "f",
  im: "l",
  ini: "l",
  uan: "f",
  ay: "l",
  lyn: "f",
  nh: "f",
  ni: "f",
  hong: "f",
  reva: "l",
  lin: "l",
  zhang: "l",
  kaya: "l",
  itsa: "f",
  lan: "f",
  mar: "f",
  heva: "l",
  hang: "f",
  ion: "f",
  ova: "l",
  uba: "f",
  leva: "l",
  a: "f",
  ieva: "l",
  deva: "l",
  e: "f",
  ke: "l",
  thu: "f",
  yha: "l",
  m: "f",
  y: "f",
  tsya: "l",
  iska: "f",
  ther: "f",
  schi: "l"
};

// index.ts
function _getMatchingSuffix(name, suffixes) {
  let search;
  for (let start = name.length; start > 0; start--) {
    search = name.slice(-start);
    if (typeof suffixes[search] === "string")
      return [search, suffixes[search]];
  }
  return ["", suffixes[""] || ""];
}
function _vokativWomanFirstName(name) {
  return name.slice(-1) === "a" ? name.slice(0, -1) + "o" : name;
}
function _vokativWomanLastName(name) {
  return name;
}
function _vokativMan(name) {
  const [search, suffix] = _getMatchingSuffix(name, man_suffixes_default);
  let ret = name.slice(0, name.length - ((search == null ? void 0 : search.length) || 0));
  return `${ret}${suffix}`;
}
function isWoman(nameString) {
  const name = nameString.toLowerCase();
  return _getMatchingSuffix(name, man_vs_woman_suffixes_default)[1] === "w";
}
function vocative(nameString, womanBool, lastName) {
  const name = nameString.toLowerCase();
  let woman = womanBool === void 0 ? isWoman(name) : womanBool;
  if (woman) {
    if (lastName === void 0)
      lastName = (_getMatchingSuffix(name, woman_first_vs_last_name_suffixes_default)[1] || "l") === "l";
    return lastName ? _vokativWomanLastName(name) : _vokativWomanFirstName(name);
  } else {
    return _vokativMan(name);
  }
}
export {
  isWoman,
  vocative
};
